export default "__VITE_ASSET__vJfThvBW__"